<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-3 pt-md-5">
          <div class="row align-items-center pt-4">
            <div class="col-lg-6 col-7">

            </div>
      </div>
  
    </base-header>
     <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
 
          <div class="col-md-4">
            <div class="form-group  mb-0">
              <base-input placeholder="Search"
                class="input-group-alternative  mb-0"
                alternative=""
                addon-right-icon="fas fa-search" v-model="search">                            
              </base-input>
            </div>

          </div>
            <div class="col">
              <base-button type="warning" class="btn-sm" @click="filter=true">Lọc</base-button>
              <base-button type="info" class="btn-sm" @click="exportFile">xuất báo cáo</base-button>
              <modal :show.sync="filter">
                <template slot="header">
                  <h5 class="modal-title" id="Filter">Lọc</h5>
                </template>
                <div>

                  <div class="row">
                    <div class="col">
                      <label>Số dòng</label>
                      <base-input class="mb-0">
                        <select class="form-control" v-model.number="limit">
                          <option value=50>50</option>
                          <option value=100>100</option>
                          <option value=200>200</option>
                        </select>
                      </base-input>
                    </div>
                    <div class="col">
                      <label>Đối tượng</label>
                      <select class="form-control" v-model.number="type">
                        <option selected value=0></option>
                        <option value=1>Khách Hàng</option>
                        <option value=2>Đối Tác</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <label>Từ ngày</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-pickr slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="fromDate">
                      </flat-pickr>
                    </base-input>
                    <label>Đến ngày</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-pickr slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="toDate">
                      </flat-pickr>
                    </base-input>
                  </div>
                  
              </div>
              <template slot="footer">
                  <base-button type="secondary" @click="cancelfilter">Hủy</base-button>
                  <base-button type="primary" @click="filter=false">Lọc</base-button>
              </template>
            </modal>
          
          </div>
          <div class="col text-right">
            
            <router-link :to="{path: '/events/add', query:{location:curlocation}}" class="btn btn-sm btn-primary" >Thêm</router-link>
            <router-link :to="{path: '/events'}" class="btn btn-sm btn-info ">Nhật Ký</router-link>
          </div>
        </div>
      </div>
      <div class="card-body">
      <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <th></th>
          <th>Đơn Vị</th>
          <th>Họ Tên</th>
          <th class="text-center">T.Khách</th>
          <th class="text-center">BS.Xe</th>
          <th class="text-center">T.Chức Năng</th>
          <th class="text-center">T.Từ</th>
          <th>Vào</th>
          <th>Ra</th>
          <th>Nội Dung</th>
          <th>Ghi Chú</th>
          <th></th>
        </thead>
        
        <tbody>
            <tr v-for="(job, inx) in jobs" :key="inx">
              <td class="p-1">

                <base-dropdown> 
                <router-link class="dropdown-item" :to="{name:'DetailEvent', params:{jobid:job._id}}">Chi Tiết</router-link>
                <router-link class="dropdown-item" v-if="permitl3" :to="{name:'EditEvent', params:{jobid:job._id}}">Sửa</router-link>
                <base-button class="dropdown-item" v-if="permitl3" @click="deleteEvent(job)">Xóa</base-button>
                </base-dropdown>

              </td>
              <th class="p-1" >
                {{ job.orgName}}
              </th>     
              <td class="p-1" >
                {{job.tenant}}
              </td>
              <td  class="p-1 text-center" width="3%" >
               {{job.l1Id}}
              </td>
              <td   class="p-1 text-center" width="3%">
                {{job.vehicleId}}
              </td>
              <td class="p-1 text-center" width="3%">{{job.l2Id}}</td>
              <td class="p-1 text-center" width="3%">{{job.l3Id}}</td>
              <td  class="p-1 text-center" >
                {{formattime(job.in1Date)}}
              </td>
              <td class="p-1 text-center">{{formattime(job.out1Date)}}</td>  
              <td class="p-1">
               {{job.content}}
              </td>
              <td class="p-1">
                {{job.notes}}
              </td>
              
            </tr>
        </tbody>
        
      </table>
    </div>
    </div>

     </div>
    <base-pagination :page-count="totalpages" align="end" v-model="page" :perPage="limit"></base-pagination>
  </div>
</template>
<script>
import { mapGetters }  from 'vuex'
import _ from "lodash"
import { Document, Packer, Paragraph, PageOrientation, Table, TableCell, TableRow, TextRun, HeadingLevel, AlignmentType, WidthType, VerticalAlign , HeightRule} from 'docx'
import { saveAs } from 'file-saver'

export default {
  data() {
    return {
      page: 1,
      limit: 50,
      totalpages: 0,
      type: 0,
      search: '',
      fromDate: null,
      toDate: null,
      filter: false,
      config: {
        enableTime:"true",
        dateFormat:"d-m-Y H:i",
        time_24hr: true
      } 
    }
  },
  computed: {
    ...mapGetters(['curlocation', 'idcs']),
        permitl1() {
          return this.$store.getters.permit_l1
        },
        permitl2() {
          return this.$store.getters.permit_l2
        },
        permitl3() {
          return this.$store.getters.permit_l3
        }
  },
  asyncComputed: {
    async jobs() {
      let data = {
        page: this.page,
        limit: this.limit,
        location: this.curlocation,
        orgType: this.type,
        searchName: this.search,
        start: this.$moment(this.fromDate, "DD-MM-YYYY HH:mm"),
        end: this.$moment(this.toDate, "DD-MM-YYYY HH:mm")
      }
      let res = await this.$http.post('/jobs/history', data )
      this.totalpages = res.data.totalPages
      return res.data.docs
    }
  },
  methods: {
    async deleteEvent(event) {
      let data = {
        jobId: event._id
      }
      if(event.openning) {
        let url = 'http://222.255.100.41:3055/';
        if(event.l1Id) {
            let data = {
            location: this.$store.getters.curlocation,
            id: event.l1Id,
            layer: 0
            };
            await this.$http.post(url+'delete', data);
          }
          if(event.l2Id) {
            let data = {
            location: this.$store.getters.curlocation,
            id: event.l2Id,
            layer: 1
            };
            await this.$http.post(url+'delete', data);
          }
          if(event.l3Id) {
            let data = {
            location: this.$store.getters.curlocation,
            id: event.l3Id,
            layer: 2
            };
            await this.$http.post(url+'delete', data);
          }
      }
      this.jobs = _.without(this.jobs,event)
      this.$http.post('/jobs/delete', data)
    },
    formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
    cancelfilter() {
      this.filter =false
      this.page =1
      this.limit = 50
      this.totalpages = 0
      this.type = 0
      this.search = ''
      this.toDate = null
      this.fromDate = null 
    },
    async exportFile() {
      let doc = new Document();
      let rows = []
      let data = {
        page: this.page,
        limit: this.limit,
        location: this.curlocation,
        orgType: this.type,
        searchName: this.search,
        start: this.$moment(this.fromDate, "DD-MM-YYYY HH:mm"),
        end: this.$moment(this.toDate, "DD-MM-YYYY HH:mm"),
        pagination: false
      }
      let res = await this.$http.post('/jobs/history', data )
      let events = res.data.docs
      let headtable= new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({text: 'Họ Tên', alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 3000,
              type: WidthType.DXA
            },
          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Số thẻ',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 1000,
              type: WidthType.DXA
            },

          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Đơn vị',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 3000,
              type: WidthType.DXA
            },

          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Số CMND',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 2000,
              type: WidthType.DXA
            },

          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Mục đích',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 3000,
              type: WidthType.DXA
            },

          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Vào',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 2000,
              type: WidthType.DXA
            }
          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Ra',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 2000,
              type: WidthType.DXA
            }
          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Người kiểm soát',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 3000,
              type: WidthType.DXA
            },
          }),
          new TableCell({
            children: [
              new Paragraph({text: 'Ghi chú',alignment: AlignmentType.CENTER})
            ],
            width: {
              size: 3000,
              type: WidthType.DXA
            },

          }),
        ]
      })
      rows.push(headtable)
      for(let i=0;i<events.length;i++) {
        let row = new TableRow({
          children:[
            new TableCell({
              children: [
                new Paragraph({text:events[i].tenant})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:events[i].l1Id})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:events[i].orgName})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:events[i].tenantNational})]
            }),
            new TableCell({
              children: [
                new Paragraph({text: events[i].content})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:this.formattime(events[i].in1Date)})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:this.formattime(events[i].out1Date)})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:events[i].l3Proctor})]
            }),
            new TableCell({
              children: [
                new Paragraph({text:events[i].notes})]
            })
          ]
        })
        rows.push(row)
      }
       //title
      const table = new Table({
        rows: [
          new TableRow({
            children: [
              new TableCell({
                children: [],
                width: {
                  size: 2000,
                  type: WidthType.DXA
                }
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({text:'QUY ĐỊNH VẬN HÀNH, KHAI THÁC IDC ',size: 24})
                    ],
                    
                    alignment: AlignmentType.CENTER,
                    spacing: {
                      after: 150,
                    },

                  }), 
                  new Paragraph({
                    children: [
                      new TextRun({text:'Mã số: QyĐ-12.2019/VNPT IT- IDC-QLCL&HT', size: 24})
                    ],                
                    alignment: AlignmentType.CENTER,
                    spacing: {
                      after: 150,
                    },
                
                  })
                ],
                width: {
                  size: 7000,
                  type: WidthType.DXA
                },
                verticalAlign: VerticalAlign.CENTER
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({text:'Lần ban hành: 02', size: 23})
                    ],
                    
                  spacing: {
                    after: 150,
                  },
                }), 
                  new Paragraph({
                    children: [
                      new TextRun({text:'Ngày hiệu lực:',size:23}),
                    ],
                    
                    spacing: {
                      after: 150,
                    },
      
                })
              ],
                width: {
                  size: 3000,
                  type: WidthType.DXA
                }
              }),
            ],
            height: {value: 1500, rule: HeightRule.DXA},
          }),      
        ],
        alignment: AlignmentType.CENTER
      });

      //title
      const title = new Paragraph({
        children:[
          new TextRun({text: "MẪU NHẬT KÝ VÀO/RA IDC", bold: true, color: 121212}),
          
        ],    
        heading: HeadingLevel.HEADING_1,
        alignment: AlignmentType.CENTER,
        spacing: {
          before: 200
        }
      })
      
      // mau
      const mau = new Paragraph({
        children: [
          new TextRun({text: 'Mẫu: NK-VHKT-11', size: 20})
        ],
        alignment: AlignmentType.RIGHT,
      })

      //
      const contextTable = new Table({
        rows: rows,
        tableHeader: true
      })

       //report
      doc.addSection({
        size: {
          orientation: PageOrientation.LANDSCAPE,
        },
        children: [table,
          title,
          mau,
          contextTable
        ],
      })
      // To export into a .docx file
      Packer.toBlob(doc).then(blob => {
        saveAs(blob, "detailed_report.docx");

      });
    }
    
  },
  mounted() {
  },
}
</script>
<style>

</style>